import { render, staticRenderFns } from "./PositionCapacityIcon.vue?vue&type=template&id=08b58fb8&scoped=true"
import script from "./PositionCapacityIcon.vue?vue&type=script&lang=js"
export * from "./PositionCapacityIcon.vue?vue&type=script&lang=js"
import style0 from "./PositionCapacityIcon.vue?vue&type=style&index=0&id=08b58fb8&prod&lang=css"
import style1 from "./PositionCapacityIcon.vue?vue&type=style&index=1&id=08b58fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b58fb8",
  null
  
)

export default component.exports